import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAdminContribution, useReconcilePayment } from "../../hooks/useAdmin";
import { useTarget } from "../../hooks/useSavings";
import Card from "../../components/ui/Card";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import Select from "../../components/ui/Select";
import api from "../../api/client";

const fmt = (n:number) => new Intl.NumberFormat("en-NG",{style:"currency",currency:"NGN", currencyDisplay:"symbol",maximumFractionDigits:0}).format(n);
const fmtDate = (d:string) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";

export default function MemberReconciliationDetailsPage() {
  const { id }   = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const { data: data }          = useAdminContribution(id!)     as any;

  const reconcile = useReconcilePayment();
  const {account = {}} = data || {};
  const [payType, setPayType] = useState("savings");
  const [amount,    setAmount]    = useState("5000");
  const { data: targetValues, isPulling } = useTarget(account?.[0]?.member_id || "") as any;
  const [cadence,   setCadence]   = useState("monthly");
  const [repayAmount, setRepayAmount] = useState("0");
  const [reference, setReference] = useState("");
  const [entryDate, setEntryDate] = useState("");

  if (!id) return <div className="p-8 text-center text-slate-400">Loading…</div>;

  const statColor = (s:string) => s==="active"?"emerald":s==="suspended"?"red":"amber";

  const handlePayment = async () =>{
    try {
      // Send reference.reference to your Node.js backend for verification
      let payAccount = "savings";
      if (payType==="savings") { payAccount = "savings"}
      if (payType==="investment") { payAccount = "investment"}
      if (payType==="targeted") { payAccount = "targeted"}
      
      const response = await reconcile.mutate({id:id,memberId:id,reference: reference,amount:amount, cadence:"one-off",repay:repayAmount,payType:payType,accountType:payAccount,entryDate:entryDate});
      // const response = await api.post('/admin/members/reconcile-account', {
      //   memberId:id,reference: reference,amount:amount, cadence:"one-off",repay:repayAmount,payType:payType,accountType:payAccount
      // });
      
      //if (response.data.success) {
      if (1==1) {
        alert("Payment verified successfully on the server! Order complete.");
        //setFeedback("✅ Contribution processed successfully!");
      } else {
        alert("Payment verification failed.");
      }
    } catch (error) {
      alert("Server error verifying payment.: "+error);
    }
  }

  return (
    <div>
      <Button variant="outline" size="sm" onClick={() => navigate("/admin/contribution")} className="mb-5">← Back</Button>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 mb-4">
        {/* Profile */}
        <Card className="lg:col-span-2">
            <p className="text-sm font-medium text-slate-700 mb-4">Reconcile contribution / Loan re-payment</p>
          <Input label="Payment Reference" type="text" value={reference} onChange={setReference} placeholder="Enter payment ref." />
          <Select label="Payment type" value={payType} onChange={setPayType} options={[
            {value:"", label:"Select payment type"},
            {value:"savings", label:"Savings"},
            {value:"loan-repayment",label:"Loan repayment"},
            {value:"both",label:"Contribute and repay loan"},
            {value:"investment", label:"Investment"},            
            {value:"targeted", label:"Targeted Savings"}]} />
          {payType ==='targeted'? <em className="text-sm md:text-sm font-small mt-1 text-amber-600">{targetValues?.length > 0? "Purpose of saving:" : ""} {targetValues?.[0]?.purpose}</em> : ""}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2" style={{width:"100%"}}>
            <div>
              <Input label="Amount (NGN)" type="number" value={amount} onChange={setAmount} placeholder="5000" />
            </div>            
            <div>
              {
                payType ==='both'? <Input label="Loan repay amount (NGN)" type="number" value={repayAmount} onChange={setRepayAmount} placeholder="500" /> :
                payType ==='targeted'? 
                <>
                  {isPulling? <Button variant="amber" size="sm" onClick={() => navigate(`/settarget/${account?.[0]?.member_id}`)}>Set Target</Button> 
                  : <span>{targetValues?.length > 0? <em className="text-sm md:text-sm font-small mt-1 text-amber-600">Target: { fmt(targetValues?.[0]?.target_amount)}</em> 
                  : <Button variant="amber" size="sm" onClick={() => navigate(`/settarget/${account?.[0]?.member_id}`)}>Set Target</Button>}
                    </span>
                  }
                </>
                : <span></span>
              }
            </div>
          </div>
          <Input label="Payment Date" type="date" value={entryDate} onChange={setEntryDate} placeholder="09/30/2026"/>
          <Select label="Cadence" value={cadence} onChange={setCadence} options={[
            { value:"daily",   label:"Daily"   },
            { value:"weekly",  label:"Weekly"  },
            { value:"monthly", label:"Monthly" },
          ]} />
          
          <div className="flex gap-2">
            {/* <Button onClick={commitPayment} className="flex-1 justify-center" disabled={contribute.isPending}>
              {contribute.isPending ? "Processing…" : "▶ Pay now"}
            </Button> */}
            
            <Button className="flex-1 justify-center" onClick={handlePayment} >              
              Reconcile Payment
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
